document.addEventListener("turbolinks:load", function() {
	$(document).on("click","[data-toggle-form-field]", function() {
    $("#"+$(this).data("toggle-form-field")).prop('disabled', !$(this).prop("checked"));
    $("#"+$(this).data("toggle-form-field")).focus();
	})
})
